import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import htmlToDom from "html-react-parser";
// import "/assets/scss/components/_disruptor.scss";

const storageKey = "SurveyShown";

const Disruptor = ({ text, headline, opener, link, cta }) => {
  const [showPopup, setShowPopup] = useState(
    localStorage.getItem(storageKey) || false
  );

  useEffect(() => {
    // Check local storage to see if the user has already closed the popup
    const hasClosedPopup = localStorage.getItem(storageKey);
    if (hasClosedPopup) {
      setShowPopup(false);
    }
  }, []);

  const handleClosePopup = () => {
    // Save the user's interaction in local storage
    localStorage.setItem(storageKey, "true");
    setShowPopup(false);
  };

  const openLinkInPopup = (e) => {
    e.preventDefault();

    $.magnificPopup.open({
      items: {
        src: link, // Use the link as the source for the iframe
        type: "iframe",
        disableOn: function () {
          if ($(window).width() < 600) {
            return false;
          }
          return true;
        },
        closeOnBgClick: true,
        closeBtnInside: true,
        callbacks: {
          parseAjax: function (mfpResponse) {
            // var $contentData = $(mfpResponse.data);
            // mfpResponse.data = $contentData;
            $(".mfp-preloader").remove();
          },
        },
      },
    });
  };

  return (
    <div className="disruptor-container">
      <button
        className={`disruptor-button ${showPopup ? "show-tooltip" : ""}`}
        onClick={() => setShowPopup(!showPopup)}
      >
        {opener ? opener : "Survey"}
      </button>
      {showPopup && (
        <div className="disruptor-tooltip" onClick={handleClosePopup}>
          <div className="disruptor-tooltip__close">
            <svg className="icon close" width="12" height="12">
              <use href="#close"></use>
            </svg>
          </div>
          <div className="t c m-0 bordered">
            <div className="p-2 small">
              {headline ? (
                <h4 className="h6 normal hl mt-0 mb-1 p-0">{headline}</h4>
              ) : (
                ""
              )}
              {text ? <p className="small">{htmlToDom(text)}</p> : ""}
              {link ? (
                <a
                  href={link}
                  className="btn btn--primary btn--sm popup-form"
                  target="_blank"
                  onClick={openLinkInPopup}
                >
                  {cta}
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Disruptor;

// ReactDOM.render(
//     <React.StrictMode>
//       <Disruptor />
//     </React.StrictMode>,
//     document.getElementsByTagName('Disruptor')[0]
//   );

let disruptorContainer = document.getElementById("disruptor");
if (disruptorContainer !== undefined && disruptorContainer !== null) {
  const DisruptorRoot = ReactDOM.createRoot(disruptorContainer);
  DisruptorRoot.render(
    <Disruptor
      headline={disruptorContainer.getAttribute("headline")}
      text={disruptorContainer.getAttribute("text")}
      link={disruptorContainer.getAttribute("link")}
      cta={disruptorContainer.getAttribute("cta")}
      opener={disruptorContainer.getAttribute("opener")}
    />
  );
}
